// Utility functions for UI components
export const formatPrice = (price) => {
  return `₹${price.toLocaleString('en-IN')}`;
};

export const formatReviewCount = (count) => {
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}K`;
  }
  return count.toString();
};

export const formatCustomerCount = (count) => {
  if (count >= 1000000) {
    return `${(count / 1000000).toFixed(1)}M+`;
  } else if (count >= 1000) {
    return `${(count / 1000).toFixed(0)}K+`;
  }
  return count.toString();
};

export const calculateDiscount = (originalPrice, currentPrice) => {
  const discount = ((originalPrice - currentPrice) / originalPrice) * 100;
  return Math.round(discount);
};

export const generateGridClasses = (config) => {
  return Object.values(config).join(' ');
};

export const combineClasses = (...classes) => {
  return classes.filter(Boolean).join(' ');
};
